import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const navLinkClass =
    'text-white/90 hover:text-white transition-colors font-medium';

  return (
    <header className="bg-blue-900 text-white shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-14 md:h-16">
          {/* Brand - LHS */}
          <Link to="/" className="text-xl font-bold text-white hover:text-white/95 transition-colors">
            GigPayDay
          </Link>

          {/* Nav - RHS */}
          <nav className="flex items-center gap-6 md:gap-8">
            <a href="#workers" className={navLinkClass}>
              Workers
            </a>
            <a href="#payers" className={navLinkClass}>
              Payers
            </a>
            <a href="#payments" className={navLinkClass}>
              Payments
            </a>
            <a href="#about" className={navLinkClass}>
              About
            </a>
            <Link to="/auth/register" className={navLinkClass}>
              Sign Up
            </Link>
            <Link
              to="/auth/login"
              className="bg-white text-blue-900 px-4 py-2 rounded-lg font-medium hover:bg-blue-50 transition-colors"
            >
              Login
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
